import useAppStore from "../store";
import * as amplitude from '@amplitude/analytics-browser';

const useAmplitude = () => {
    const {allowAnalytics, isTest} = useAppStore();

    const send = (name: string, payload?: object, force: boolean = false) => {
        if((!isTest && allowAnalytics && import.meta.env.VITE_ANALYTICS_MODE !== "dev") || force) {
            amplitude.track(name, payload);
        } else {
            console.log("SENDING EVENT", name, payload);
        }
    }

    const getOrder = (name: string) => {
        const order = name.split('-');
        return order.length > 1 ? parseInt(order[1]) : null
    }

    return { send, getOrder }
}

export default useAmplitude;